import { Header } from "../misc"
import { WeeklyCalendar } from './UI/WeeklyCalendar'
import { MonthlyCalendar } from './UI/MonthlyCalendar'

/**
 * ### [Route for ('/calendar/weekly')]
 * 
 * This component shows the calendar for the current week.
 * The calendar shows projects that are due in that week.
 */
export function WeeklyCalendarPage() {
    return (
        <WeeklyCalendar />
    )
}

/**
 * ### [Route for ('/monthly_calendar')]
 * 
 * This component shows the calendar for the current month.
 * The calendar shows projects that are due in that month.
 * 
 * TODO:
 * - Show links to each project due
 */
export function MonthlyCalendarPage() {
    return (
        <MonthlyCalendar />
    )
}

export function MonthlyCalendarPopup() {
    return (
        <>
        <Header />

        <MonthlyCalendar />
        </>
    )
}

export function WeeklyCalendarPopup() {
    return (
        <>
        <Header />
        
        <WeeklyCalendar />
        </>
    )
}


